import { DOCUMENT } from '@angular/common';
import type { AfterViewInit } from '@angular/core';
import { Directive, inject } from '@angular/core';
import { ActivatedRoute } from '@angular/router';

@Directive({
  selector: '[appScrollToFragment]',
  standalone: true,
})
export class ScrollToFragmentDirective implements AfterViewInit {
  readonly #route = inject(ActivatedRoute);
  readonly #document = inject(DOCUMENT);
  #firstLoad = true;

  ngAfterViewInit(): void {
    this.#route.fragment.subscribe(fragment => {
      if (fragment) {
        const el = this.#document.getElementById(fragment);
        if (el === null) {
          return;
        }

        if (this.#firstLoad) {
          this.#firstLoad = false;
          window.scrollTo(0, 0);

          setTimeout(() => {
            el.scrollIntoView({ behavior: 'smooth' });
          }, 100);
          return;
        }

        el.scrollIntoView({ behavior: 'smooth' });
      }
    });

    this.#firstLoad = false;
  }
}
